import React from "react";
import theme from "../../../styles/theme";

const CardsContainer = ({
  children,
  gap = 16,
  justify = "flex-start",
  align = "center",
  wrap = true,
}) => {
  return (
    <div
      style={{
        width: "100%",              // ← permet le centrage réel du contenu
        display: "flex",
        justifyContent: "center",   // ← centre l’élément interne
        alignItems: align,
        flexWrap: wrap ? "wrap" : "nowrap",
        gap: `${gap}px`,
        padding: theme.spacing.md,
      }}
    >
      {children}
    </div>
  );
};


export default CardsContainer;
